
export const getIds = ({ productClp }) => productClp.list.allIds;
export const getByProductId = ({ productClp }) => productClp.byProductId;
